import { create } from 'zustand';
import { combine } from 'zustand/middleware';

export const useChatStore = create(
  combine(
    {
      isOpen: false,
      defaultLayout: undefined as number[] | undefined,
    },
    (set) => {
      return {
        openChat: () => {
          set({ isOpen: true });
        },
        closeChat: () => {
          set({ isOpen: false });
        },
        toggleChat: () => {
          set((state) => ({ isOpen: !state.isOpen }));
        },
        setDefaultLayout: (layout: number[] | undefined) => {
          set({ defaultLayout: layout });
        },
      };
    },
  ),
);
